import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import UserProfile from "../components/UserProfile";
import MyListings from "../components/MyListings";
import Package from "../components/Package";
import API_BASE from "../config/api";
import Dashboard from "../components/Dashboard";
import CommentsReviews from "../components/CommentsReviews";
import UpgradeListing from "../components/UpgradeListing";
import WebHome from "../components/WebHome";
import WebAboutMe from "../components/WebAboutMe";
import WebPortfolio from "../components/WebPortfolio";
import WebBiography from "../components/WebBiography";
import WebContactMe from "../components/WebContactMe";
import Wallet from "../components/Wallet";

export default function Admin() {
    const location = useLocation();
    const params = new URLSearchParams(location.search);

    const paymentStatus = params.get("payment");
    const listinguidFromUrl = params.get("listinguid");




    const getInitialPage = () => {
        if (paymentStatus === "success" || paymentStatus === "failed") {

            // 🔥 Wallet payment (NO listinguid)
            if (params.get("page") === "Wallet") {
                return "Wallet";
            }


            // 🔒 Listing payment (existing behaviour)
            if (listinguidFromUrl) {
                return "UpgradeListing";
            }
        }

        return params.get("page") || "Dashboard";
    };

    const [activePage, setActivePage] = useState(getInitialPage);



    const [username, setUsername] = useState("");
    const [userData, setUserData] = useState(null);
    const [sidebarOpen, setSidebarOpen] = useState(false);


    const userid = new URLSearchParams(location.search).get("userid");
    const [selectedListingUid, setSelectedListingUid] = useState(null);



    useEffect(() => {
        if (
            (paymentStatus === "success" || paymentStatus === "failed") &&
            listinguidFromUrl
        ) {
            setSelectedListingUid(listinguidFromUrl);
            setActivePage("UpgradeListing");

            // 🔁 sync URL with page
            const url = new URL(window.location.href);
            url.searchParams.set("page", "UpgradeListing");
            window.history.replaceState({}, "", url);
        }
    }, [paymentStatus, listinguidFromUrl]);

    useEffect(() => {
        if (
            (paymentStatus === "success" || paymentStatus === "failed") &&
            params.get("page") === "Wallet"
        ) {
            setActivePage("Wallet");

            // 🔒 lock Wallet page until it handles toast
            const url = new URL(window.location.href);
            url.searchParams.set("page", "Wallet");
            window.history.replaceState({}, "", url);
        }
    }, [paymentStatus]);




    useEffect(() => {
        const saved = localStorage.getItem("user");
        if (saved) {
            try {
                const u = JSON.parse(saved);
                setUsername(u.fullname ?? "Admin");
            } catch (e) {
                console.error(e);
            }
        }
    }, []);

    const user = JSON.parse(localStorage.getItem("user"));
    const userId = user?.personaluid;

    const [walletBalance, setWalletBalance] = useState(0);

    useEffect(() => {
        if (!userId) return;

        fetch(`${API_BASE}/api/get_wallet.php?user_id=${userId}`)
            .then(res => res.json())
            .then(data => {
                if (data.success) {
                    setWalletBalance(data.balance || 0);
                }
            })
            .catch(() => { });
    }, [userId]);

    useEffect(() => {
        if (!userid) return;
        fetch(`${API_BASE}/api/userdata.php?userid=${userid}`)
            .then(res => res.json())
            .then(res => res.success && setUserData(res.data))
            .catch(err => console.error(err));
    }, [userid]);
    const handleLogout = () => {
        console.log("LOGOUT CLICKED");   // 🔥 ADD THIS
        localStorage.removeItem("user");
        window.location.href = "/";       // full reload
    };
    return (
        <div className="admin-layout d-flex flex-column vh-100">

            {/* NAVBAR */}
            <nav className="navbar sticky-top custom-navbar px-3">
                <div className="container-fluid d-flex justify-content-between align-items-center">

                    {/* Mobile Sidebar Toggle */}
                    <button className="btn d-md-none mobile-toggle" onClick={() => setSidebarOpen(!sidebarOpen)}>
                        <i className="bi bi-list"></i>
                    </button>

                    {/* LOGO */}
                    <img
                        src="/logo.png"
                        alt="Logo"
                        className="admin-logo"
                    />

                    {/* RIGHT SECTION */}
                    <div className="d-flex align-items-center gap-4">
                        <div
                            className="d-flex align-items-center px-3 py-1 rounded"
                            style={{
                                background: "#ecfdf5",
                                border: "1px solid #bbf7d0"
                            }}
                        >
                            <i className="bi bi-wallet2 text-success me-2"></i>
                            <span className="fw-semibold text-success">
                                ₹ {walletBalance.toLocaleString()}
                            </span>
                        </div>

                        <a
                            href="/add-listing"
                            className="d-flex align-items-center gap-2 text-decoration-none"
                            style={{ cursor: "pointer" }}
                        >
                            <i className="bi bi-plus-circle-fill text-success fs-4"></i>
                            <span className="fw-semibold text-dark">Add Listing</span>
                        </a>


                        {/* Notification Dropdown */}
                        <div className="dropdown">
                            <button className="icon-btn" data-bs-toggle="dropdown">
                                <i className="bi bi-bell-fill"></i>
                            </button>

                            <ul className="dropdown-menu dropdown-menu-end shadow-lg animate-dropdown">
                                <li className="dropdown-header fw-semibold text-primary">
                                    <i className="bi bi-bell me-2 text-warning"></i> Notifications
                                </li>
                                <li><hr /></li>

                                {/* Example Items */}
                                <li>
                                    <span className="dropdown-item d-flex align-items-center">
                                        <i className="bi bi-check-circle-fill me-2 text-success"></i>
                                        No new notifications
                                    </span>
                                </li>
                            </ul>
                        </div>
                        {/* ADD LISTING BUTTON IN NAVBAR */}



                        {/* Profile Dropdown */}
                        <div className="dropdown">
                            <button className="profile-btn" data-bs-toggle="dropdown">
                                <img
                                    src="Profile_Avtar.png"
                                    alt="Profile"
                                    className="rounded-circle"
                                    width="40" height="40"
                                />
                            </button>

                            <ul className="dropdown-menu dropdown-menu-end shadow-lg animate-dropdown">



                                {/* Profile */}
                                <li>
                                    <button
                                        className="dropdown-item d-flex align-items-center"
                                        onClick={() => setActivePage("UserProfile")}
                                    >
                                        <i className="bi bi-person-circle me-2 text-primary"></i>
                                        Profile
                                    </button>
                                </li>

                                <li><hr className="dropdown-divider" /></li>
                                <li>
                                    <a className="dropdown-item d-flex align-items-center" href="/">
                                        <i className="bi bi-arrow-return-left me-2 text-purple"></i>
                                        Return to Website
                                    </a>
                                </li>

                                <li>
                                    <button
                                        className="dropdown-item d-flex align-items-center text-danger"
                                        onClick={handleLogout}
                                    >
                                        <i className="bi bi-box-arrow-right me-2"></i>
                                        Logout
                                    </button>
                                </li>

                            </ul>
                        </div>

                        <style>{`
                            .dropdown-item i {
                                font-size: 1.1rem;
                            }
                            .dropdown-item {
                                padding: 8px 14px;
                                border-radius: 6px;
                            }
                            .dropdown-item:hover {
                                background: #f1f6ff;
                            }
                        `}</style>

                    </div>
                </div>

                {/* NAVBAR CSS */}
                <style>{`
        .custom-navbar {
            height: 65px;
            background: #ffffff;
            border-bottom: 1px solid #e7e7e7;
            box-shadow: 0 1px 8px rgba(0,0,0,0.06);
        }

        /* Logo Responsive */
        .admin-logo {
            height: 50px;
            transition: 0.3s;
        }
        @media (max-width: 768px) {
            .admin-logo {
                height: 42px;
            }
        }

        /* Mobile Toggle Icon */
        .mobile-toggle i {
            font-size: 1.7rem;
            color: #2563eb;
        }

        /* Icon Button Styling */
        .icon-btn {
            background: #eef3ff;
            border: none;
            padding: 8px 11px;
            border-radius: 50%;
            color: #2563eb;
            transition: 0.2s;
        }
        .icon-btn:hover {
            background: #dce8ff;
            transform: translateY(-2px);
        }

        /* Profile image button */
        .profile-btn {
            border: none;
            background: transparent;
            padding: 0;
            border-radius: 50%;
            transition: 0.2s;
        }

        .profile-btn img {
            border: 2px solid #e3eaff;
            box-shadow: 0 0 5px rgba(0,0,0,0.08);
        }

        .profile-btn:hover img {
            transform: scale(1.06);
            border-color: #2563eb;
        }

        /* Dropdown animation */
        .animate-dropdown {
            animation: fadeIn 0.25s ease-in-out;
        }
        @keyframes fadeIn {
            from { opacity: 0; transform: translateY(-6px); }
            to { opacity: 1; transform: translateY(0); }
        }

    `}</style>
            </nav>


            {/* MAIN */}
            <div className="d-flex flex-grow-1 overflow-hidden">

                {/* SIDEBAR */}
                <div className={`sidebar-container ${sidebarOpen ? "open" : ""}`}>
                    <Sidebar
                        active={activePage}
                        onChange={(p) => {
                            setActivePage(p);
                            setSidebarOpen(false); // auto close on mobile 
                        }}
                        sidebarOpen={sidebarOpen}   // <-- pass sidebarOpen prop 
                    />
                </div>

                {/* Overlay for mobile to close sidebar */}
                {sidebarOpen && <div className="sidebar-overlay" onClick={() => setSidebarOpen(false)}></div>}


                {/* CONTENT */}
                <div className="flex-grow-1 bg-light p-4 overflow-auto">
                    {activePage === "Dashboard" && <Dashboard userData={userData} />}
                    {activePage === "UserProfile" && <UserProfile userData={userData} />}
                    {activePage === "MyListings" && (
                        <MyListings
                            userData={userData}
                            onUpgrade={(listinguid) => {
                                setSelectedListingUid(listinguid);
                                setActivePage("UpgradeListing");
                            }}
                        />
                    )}

                    {activePage === "CommentsReviews" && <CommentsReviews userData={userData} />}
                    {activePage === "UpgradeListing" && (
                        <UpgradeListing listinguid={selectedListingUid} />
                    )}

                    {activePage === "WebHome" && <WebHome userData={userData} />}
                    {activePage === "WebAboutMe" && <WebAboutMe userData={userData} />}
                    {activePage === "WebPortfolio" && <WebPortfolio userData={userData} />}
                    {activePage === "WebBiography" && <WebBiography userData={userData} />}
                    {activePage === "WebContactMe" && <WebContactMe userData={userData} />}
                    {activePage === "Wallet" && (
                        <Wallet
                            userData={userData}
                            balance={walletBalance}
                            onBalanceUpdate={setWalletBalance}
                        />
                    )}

                </div>
            </div>

            {/* SIDEBAR RESPONSIVE CSS */}
            <style>{`
                /* Desktop */
                @media (min-width: 768px) {
                    .sidebar-container {
                        width: 240px;
                        height: calc(100vh - 56px);
                        position: sticky;
                        top: 56px;
                        border-right: 1px solid #ddd;
                        background: #fff;
                    }
                }

                /* Mobile slide-out */
                @media (max-width: 768px) {
                    .sidebar-container {
                        width: 240px;
                        position: fixed;
                        top: 0;
                        left: -260px;
                        height: 100%;
                        background: #fff;
                        z-index: 1055;
                        transition: all 0.3s ease;
                        box-shadow: 0 0 15px rgba(0,0,0,0.2);
                    }
                    .sidebar-container.open {
                        left: 0;
                    }
                }
                    .sidebar-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.3);
  z-index: 1050;
}

            `}</style>
        </div>
    );
}
